import type { LockScreenTexts } from "@ews-admin/global-design-system";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

/** Translated texts of the design-system LockScreen (MED-1621). */
export const usePinLockTexts = (otpDescription?: string): LockScreenTexts => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      dialogLabel: t("pinLock.dialogLabel"),
      createTitle: t("pinLock.createTitle"),
      confirmTitle: t("pinLock.confirmTitle"),
      unlockTitle: t("pinLock.unlockTitle"),
      currentTitle: t("pinLock.currentTitle"),
      newTitle: t("pinLock.newTitle"),
      otpTitle: t("pinLock.otpTitle"),
      otpDescription,
      otpLabel: t("pinLock.otpLabel"),
      otpSubmit: t("pinLock.otpSubmit"),
      mismatchError: t("pinLock.mismatch"),
      forgot: t("pinLock.forgot"),
      cancel: t("pinLock.cancel"),
      erase: t("pinLock.erase"),
      keypad: t("pinLock.keypad"),
      progress: (filled: number, total: number) =>
        t("pinLock.progress", { filled, total }),
      signOut: t("pinLock.signOut"),
      digit: (position: number, total: number) =>
        t("pinLock.digit", { position, total }),
    }),
    [t, otpDescription]
  );
};
